import { useState, useEffect } from 'react';
import API_CONFIG from '../config/api';

interface AdminLesson {
  id: number;
  category: string;
  title: string;
  duration: string;
  description: string;
  tipTitle: string;
  tipText: string;
  driveVideoId: string | null;
  driveThumbnailId: string | null;
  drivePreviewId: string | null;
}

export const useAdminLessons = () => {
  const [lessons, setLessons] = useState<AdminLesson[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchLessons = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}/api/admin/lessons`);
      if (!response.ok) {
        throw new Error('Не удалось загрузить уроки');
      }
      const data = await response.json();
      if (data.success) {
        setLessons(data.lessons);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Неизвестная ошибка');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLessons();
  }, []);

  return { lessons, loading, error, refetch: fetchLessons };
};

export const useUpdateLessonTitle = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateTitle = async (lessonId: number, title: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}/api/admin/lesson/${lessonId}/title`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ title }),
      });

      if (!response.ok) {
        throw new Error('Не удалось обновить название урока');
      }

      const data = await response.json();
      if (!data.success) {
        throw new Error(data.message || 'Ошибка обновления');
      }

      return data;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Неизвестная ошибка';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { updateTitle, loading, error };
};
